import { render, staticRenderFns } from "./ytRecordDialog.vue?vue&type=template&id=6a2a9780&scoped=true"
import script from "./ytRecordDialog.vue?vue&type=script&lang=js"
export * from "./ytRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./ytRecordDialog.vue?vue&type=style&index=0&id=6a2a9780&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a9780",
  null
  
)

export default component.exports